var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8361 30.1438C6.82712 32.2407 1.78478 37.32 0.149001 44.4532C-0.326932 46.4941 0.410533 47.0897 1.32611 47.372C7.62123 49.3105 19.2727 49.999 23.8447 49.999C25.4388 49.999 27.9165 49.9071 30.7042 49.7162V37.6095H38.1118C39.1292 36.1186 39.8483 35.0466 40.5207 33.6659C38.3875 32.1132 35.8259 30.9215 32.8534 30.1431L24.5745 37.0775C24.1532 37.4305 23.5388 37.4305 23.1175 37.0775L14.8361 30.1438Z",
    fill: "#373163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8458 0C16.8807 0 11.2734 5.66697 11.2734 12.7063V13.5653C11.2734 20.6045 16.8809 26.2716 23.8458 26.2716C30.8107 26.2716 36.4182 20.6046 36.4182 13.5653V12.7063C36.4182 5.6671 30.8107 0 23.8458 0Z",
    fill: "#373163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4961 40.4021V48.534H36.7697V40.4021H33.4961Z",
    fill: "#373163"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8142 30.251C45.2139 30.3434 44.6442 30.7924 44.4067 31.5078C43.2442 35.0071 42.5232 36.0527 41.0774 38.216L39.6172 40.402V48.5339L44.4025 49.9998H49.1434C50.9878 49.9998 52.0683 49.554 52.4232 47.7728L53.9391 40.6644C54.1766 39.4788 53.8345 37.5195 51.7399 37.5195H48.5031C47.7666 37.5195 46.9552 37.6613 47.1163 36.7L47.6158 33.7092C47.7756 32.7564 47.7661 31.8295 47.4094 31.1321C47.0461 30.4225 46.4147 30.1586 45.8143 30.2509L45.8142 30.251Z",
    fill: "#373163"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUf);
export default __webpack_public_path__ + "static/media/UF.aa928618a8255f3b504c44f5099bb2e5.svg";
export { ForwardRef as ReactComponent };